<div class="order-transfer-form mb-16">
  <div
    class="overlay"
    lumAppLoader
    [loading]="(isLoading$ | async) || rfqLocationStockLoading || false"
    [classes]="'loading blur'"
  ></div>
  <form [formGroup]="form">
    <div class="flex justify-content-end">
      <button
        type="button"
        class="lum-button mb-4"
        [matMenuTriggerFor]="menu"
        [disabled]="submittingForm$ | async"
      >
        <lum-ui-icon class="mr-2" icon="content-save" color="#ffffff"></lum-ui-icon>
        Save Order
      </button>
      <mat-menu class="lum-mat-menu" #menu="matMenu">
        <button
          mat-menu-item
          type="button"
          (click)="onTransfer(orderTransferStatus.POSTED)"
        >
          Mark as Posted
        </button>
        <button
          mat-menu-item
          type="button"
          (click)="onTransfer(orderTransferStatus.DRAFT)"
        >
          Mark as Draft
        </button>
      </mat-menu>
    </div>
    <mat-card class="lum-mat-card">
      <mat-card-content>
        <div class="flex grow flex-column gap-4">
          <div class="flex justify-content-end">
            <div>
              <div class="lum-label">Order #</div>
              <input
                type="text"
                placeholder=""
                matInput
                class="lum-input"
                formControlName="orderNumber"
                [ngClass]="{
                  error:
                    form.get('orderNumber')?.touched &&
                    form.get('orderNumber')?.invalid,
                }"
              />
              <mat-error
                *ngIf="
                  form.get('orderNumber')?.touched &&
                  form.get('orderNumber')?.invalid
                "
                ><small class="text-red"> This field is required </small></mat-error
              >
            </div>
          </div>
          <div class="flex gap-4">
            <!-- SOURCE WAREHOUSE -->
            <div class="form-group grow">
              <div class="lum-label">Source Warehouse</div>
              <input
                type="text"
                placeholder="(Required)"
                matInput
                class="lum-input"
                formControlName="sourceWarehouse"
                [matAutocomplete]="auto"
                (input)="onSearchWarehouseChange($event, 'sourceWarehouse')"
                [ngClass]="{
                  error:
                    form.get('sourceWarehouse')?.touched &&
                    form.get('sourceWarehouse')?.invalid,
                }"
              />
              <mat-error
                *ngIf="
                  form.get('sourceWarehouse')?.touched &&
                  form.get('sourceWarehouse')?.invalid
                "
                ><small class="text-red"> This field is required </small></mat-error
              >
              <mat-autocomplete
                [displayWith]="displayWarehouseFn"
                #auto="matAutocomplete"
              >
                <ng-container *ngIf="true; else loader">
                  <mat-option
                    *ngFor="let warehouse of availableWarehouses"
                    [value]="warehouse"
                  >
                    {{ warehouse?.location_name }}
                  </mat-option>
                </ng-container>
                <ng-template #loader>
                  <mat-option>
                    <div class="flex gap-4">
                      <mat-progress-spinner
                        class="progress-spinner mt-3"
                        diameter="24"
                        mode="indeterminate"
                      ></mat-progress-spinner>
                      <small>Loading...</small>
                    </div>
                  </mat-option>
                </ng-template>
              </mat-autocomplete>
            </div>

            <div class="form-group grow">
              <div class="lum-label">Fulfillment Channel</div>
              <lum-channel-control
                formControlName="channel"
                isPushOrderToOms="true"
              ></lum-channel-control>
            </div>

            <!-- DESTINATION WAREHOUSE -->
            <div class="form-group grow">
              <div class="lum-label">Destination Warehouse</div>
              <input
                type="text"
                placeholder="(Required)"
                matInput
                class="lum-input"
                formControlName="destinationWarehouse"
                [matAutocomplete]="autoDestination"
                (input)="onSearchWarehouseChange($event, 'destinationWarehouse')"
                [ngClass]="{
                  error:
                    form.get('destinationWarehouse')?.touched &&
                    form.get('destinationWarehouse')?.invalid,
                }"
              />
              <mat-error
                *ngIf="
                  form.get('destinationWarehouse')?.touched &&
                  form.get('destinationWarehouse')?.invalid
                "
                ><small class="text-red"> This field is required </small></mat-error
              >
              <mat-autocomplete
                [displayWith]="displayWarehouseFn"
                #autoDestination="matAutocomplete"
              >
                <ng-container *ngIf="true; else loader">
                  <mat-option
                    *ngFor="let warehouse of availableWarehouses"
                    [value]="warehouse"
                  >
                    {{ warehouse?.location_name }}
                  </mat-option>
                </ng-container>
                <ng-template #loader>
                  <mat-option>
                    <div class="flex gap-4">
                      <mat-progress-spinner
                        class="progress-spinner mt-3"
                        diameter="24"
                        mode="indeterminate"
                      ></mat-progress-spinner>
                      <small>Loading...</small>
                    </div>
                  </mat-option>
                </ng-template>
              </mat-autocomplete>
            </div>

            <!-- ORDER DATE -->
            <div>
              <div class="lum-label">Order Date</div>
              <mat-form-field class="lum-datepicker-field">
                <input
                  matInput
                  formControlName="orderDate"
                  [matDatepicker]="orderDatepicker"
                  [ngClass]="{
                    error:
                      form.get('orderDate')?.touched &&
                      form.get('orderDate')?.invalid,
                  }"
                />

                <mat-datepicker-toggle
                  matSuffix
                  [for]="orderDatepicker"
                ></mat-datepicker-toggle>
                <mat-datepicker #orderDatepicker></mat-datepicker>
              </mat-form-field>
              <mat-error
                *ngIf="
                  form.get('orderDate')?.touched && form.get('orderDate')?.invalid
                "
                ><small class="text-red"> This field is required </small></mat-error
              >
            </div>
            <!-- <div>
              <div class="lum-label">Order Date</div>
              <mat-form-field class="lum-datepicker-field">
                <input
                  matInput
                  class="lum-input"
                  formControlName="orderDate"
                  [matDatepicker]="orderDatepicker"
                  [ngClass]="{
                    error:
                      form.get('orderDate')?.touched &&
                      form.get('orderDate')?.invalid
                  }"
                />
                <mat-datepicker-toggle
                  matSuffix
                  [for]="orderDatepicker"
                ></mat-datepicker-toggle>
                <mat-datepicker #orderDatepicker></mat-datepicker>
              </mat-form-field>
              <mat-error
                *ngIf="
                  form.get('orderDate')?.touched &&
                  form.get('orderDate')?.invalid
                "
                ><small class="text-red">
                  This field is required
                </small></mat-error
              >
            </div> -->

            <!-- ARRIVAL DATE -->
            <div>
              <div class="lum-label">Arrival Date</div>
              <mat-form-field class="lum-datepicker-field">
                <input
                  matInput
                  formControlName="arrivalDate"
                  [matDatepicker]="arrivalDatepicker"
                  [ngClass]="{
                    error:
                      form.get('arrivalDate')?.touched &&
                      form.get('arrivalDate')?.invalid,
                  }"
                />

                <mat-datepicker-toggle
                  matSuffix
                  [for]="arrivalDatepicker"
                ></mat-datepicker-toggle>
                <mat-datepicker #arrivalDatepicker></mat-datepicker>
              </mat-form-field>
              <mat-error
                *ngIf="
                  form.get('arrivalDate')?.touched &&
                  form.get('arrivalDate')?.invalid
                "
                ><small class="text-red"> This field is required </small></mat-error
              >
            </div>
          </div>

          <div class="flex gap-4">
            <!-- NOTE -->
            <div class="flex gap-4 w-100">
              <div class="grow">
                <div class="lum-label">Note</div>
                <textarea
                  rows="5"
                  class="lum-textarea"
                  placeholder="Add note here..."
                  formControlName="note"
                ></textarea>
              </div>

              <!-- SHIPPING INFO -->
              <div class="w-99">
                <div class="lum-label">Shipping Method</div>
                <input
                  class="lum-input"
                  type="text"
                  placeholder="(Required)"
                  formControlName="shippingMethod"
                  [ngClass]="{
                    error:
                      form.get('shippingMethod')?.touched &&
                      form.get('shippingMethod')?.invalid,
                  }"
                />
                <mat-error
                  *ngIf="
                    form.get('shippingMethod')?.touched &&
                    form.get('shippingMethod')?.invalid
                  "
                  ><small class="text-red">
                    This field is required
                  </small></mat-error
                >
              </div>
            </div>
          </div>

          <div>
            <div class="flex gap-4 w-100 align-items-center">
              <mat-checkbox
                formControlName="autoReceiveOrderOnArrival"
                class="lum-checkbox py-3"
              >
                <div class="mb-0">
                  Auto-Receive Transfer Order on Arrival Date
                  <small
                    >This will automatically create a Receiving Report entry for
                    this Transfer Order's Purchase Order on the Arrival Date</small
                  >
                </div>
              </mat-checkbox>
            </div>
            <div class="flex gap-4 w-100 align-items-center">
              <mat-checkbox
                formControlName="autoCreateRecievingReport"
                class="lum-checkbox py-3"
              >
                <div class="mb-0">Open Receiving Report Form on Close</div>
              </mat-checkbox>
            </div>
          </div>

        </div>
      </mat-card-content>
    </mat-card>

    <!-- SKUS -->
    <div class="mt-8">
      <lum-order-transfer-skus
        [form]="form"
        [itemsCost]="itemsCost"
        [settings]="settings"
        (addLineItem)="onAddLineItem($event)"
        (selectRfq)="onSelectRfqFromFormTable($event)"
        (removeLineItem)="onRemoveLineItem($event)"
        (addRowItems)="onAddRowItems($event)"
      ></lum-order-transfer-skus>
    </div>
  </form>
</div>
